import { Outlet, createRoute, useParams } from "@tanstack/react-router";
import { ClubGuard } from "@/components/ClubGuard";
import { ClubHome } from "@/components/home/ClubHome";
import { AppShell, AppSidebar } from "@/components/sidebar/AppSidebar";
import { useOrganizerClubs } from "@/lib/clubs/queries";
import {
  useLastVisitedSorted,
  useRecordClubVisit,
} from "@/lib/clubs/lastVisited";
import { rootRoute } from "./root";
import styles from "./clubs.module.scss";

function ClubsShell() {
  const { data: clubs = [] } = useOrganizerClubs();
  const sortedClubs = useLastVisitedSorted(clubs);
  return (
    <AppShell sidebar={<AppSidebar mode="navigate" clubs={sortedClubs} />}>
      <div className={styles.main}>
        <Outlet />
      </div>
    </AppShell>
  );
}

function ClubsIndex() {
  return (
    <div className={styles.index}>
      <h1 className={styles.title}>Cockpit</h1>
      <p className={styles.subtitle}>
        Pick a club from the sidebar to manage its activity.
      </p>
    </div>
  );
}

function ClubDetailHome() {
  const params = useParams({ from: clubDetailRoute.id });
  useRecordClubVisit(params.id);
  return <ClubHome clubId={params.id} />;
}

export const clubsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/clubs",
  component: () => (
    <ClubGuard>
      <ClubsShell />
    </ClubGuard>
  ),
});

export const clubsIndexRoute = createRoute({
  getParentRoute: () => clubsRoute,
  path: "/",
  component: ClubsIndex,
});

export const clubDetailRoute = createRoute({
  getParentRoute: () => clubsRoute,
  path: "/$id",
  component: () => (
    <ClubGuard requireClubId>
      <ClubDetailHome />
    </ClubGuard>
  ),
});
